import React from 'react'
import { connect } from 'react-redux'
import { Col, Container } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';

import "./styles/multipliers-styles.scss"
import { Link } from 'react-router-dom';
function Multipliers(props) {
    const MULTIPLIER = [
        { icon: "slash", heading: "Store Multiplier", class: "app-multipliers-card-white", href: "store" },
        { icon: "slash", heading: "Brand Multiplier", class: "app-multipliers-card-light", href: "brand" },
        { icon: "slash", heading: "Category Multiplier", class: "app-multipliers-card-white", href: "category" },
        { icon: "package", heading: "Product Multiplier", class: "app-multipliers-card-light", href: "product" },
    ]

    return (
        <section id="app-multipliers" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-multipliers">
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Multipliers</p>
                        <p className="app-desc">Setup  of Multipliers</p>
                    </div>

                    <div className="app-content-container">
                        <div className="app-card ">
                            <div className="app-card-content bg-white border st-default-rounded-block mb-3">
                                <div className="acc_top-bar ">
                                    {MULTIPLIER.map((e, index) =>
                                        <Col lg={11} md={12} key={index}>
                                            <div className="app-card pad-12" key={index}>
                                                <div className={`app-card-content border st-default-rounded-block ${e.class}`}>
                                                    <div className="pad-12 ">
                                                        <div className="cats-all-btns justify-content-between d-flex ">
                                                            <div className="cats-all-btns-inner d-flex flex-wrap  align-items-center">
                                                                <span className="pad-12 app-multipliers-icon me-4">
                                                                    <FeatherIcon
                                                                        icon={e.icon}
                                                                        size="40"
                                                                        className="icon text-primary" />
                                                                </span>
                                                                <div className="app-header-wrapper heading-md d-flex flex-column justify-content-start">
                                                                    <p className="text-capitalize st-fs-20 text-dark2 app-multiplier-heading">{e.heading}</p>
                                                                    <p className="text-capitalize app-multiplier-desc">manage the settings for <span>{e.heading}</span></p>
                                                                </div>
                                                            </div>
                                                            <div className="cats-all-btns-inner d-flex flex-wrap align-items-center ">
                                                                <Link
                                                                    to={`/catalog/multipliers/${e.href}`}
                                                                    className="st-btn st-btn-primary st-btn-sm no-min-width d-flex align-items-center justify-content-center me-2 pad-25-L pad-R-25 setup-btn">
                                                                    Setup
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </section >
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

// const dispatchActionsToProps = dispatch => {
//     return {
//         setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
//     }
// }

export default connect(getDataFromStore, null)(Multipliers)